import { type PivotColumnAttributes } from './generated/PivotColumnAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface PivotColumn extends PivotColumnAttributes {}

@model
class PivotColumn extends ApplicationModel {
  // Start auto-generated
  static typename: 'PivotColumn' = 'PivotColumn';
  get typename(): 'PivotColumn' {
    return 'PivotColumn';
  }

  static fields = {
    key: attr({ readable: true }),
    sortType: attr({ readable: true }),
    title: attr({ readable: true }),
  };
  // End auto-generated
}

export default PivotColumn;
